module.exports = __webpack_public_path__ + "img/doug-tuckett.0b7c233c.jpg";